const translator = {
    fields: {
        'carrier': 'Empresa transportista',
        'carrier_doc': 'CUIT Empresa transportista',
        'driver_name': 'Chofer - Nombre y Apellido',
        'driver_doc': 'Licencia de conducir',
        'estimated_load_date': 'Fecha estimada de carga',
        'load_datetime': 'Fecha de carga',
        'line_number': 'Número de linea',
        'order_volume': 'Cantidad de litros',
        'product': 'Producto',
        'provider': 'Proveedor',
        'st_company': 'Compañía ST',
        'st_number': 'Orden ST',
        'terminal': 'Destino',
        'trailer_plate': 'Patente acoplado',
        'truck_id': 'Transporte unidad',
        'truck_plate': 'Patente chasis',
        'provider_observations': 'Observaciones',
        'provider_load_volume': 'Cantidad Despachada',
        'provider_trip_receipt': 'Remito',
        'non_field_errors': 'Otros errores',

        'clear_appearance_check': 'Aspecto claro',
        'origin_reference_density': 'Densidad s/camión',
        'terminal_sample_temperature': 'Temperatura medida s/mov.',
        'terminal_sample_density': 'Densidad medida a temp. ambiente',
        'terminal_alcoholic_grade': 'Grado alcohólico s/mov.',
        'terminal_reference_density': 'Densidad s/mov.',
        'origin_alcoholic_grade': 'Grado alcohólico s/camión',
        'seals_check': 'Precintos según remito',
        'compartments': 'Cantidad de cisternas',
        'reference_density_diff': 'Diferencia entre densidades',
        'alcoholic_grade_diff': 'Diferencia entre grado alcohólico',

        'business_name': 'Razón Social',
        'cuit': 'CUIT',
        'email': 'Correo electrónico',
        'can_create_cif_trips': '¿Puede crear viajes CIF?',

        'contact': 'Contacto',
        'operation_type': 'Tipo de operación',
        'destination_area': 'Area de carga/descarga',
        'business_observations': 'Observaciones',

        'quality_letter_check': '¿Trae carta calidad proveedor?',

        'name': 'Nombre',
        'code': 'Código',
        'loading_island': 'Isla de Carga',
        'description': 'Descripción',
        'trip_type': 'Tipo de Viaje',
        'text': 'Texto'

    },
    getFieldName: (field) => {
        if(translator.fields.hasOwnProperty(field)){
            return translator.fields[field];
        }
        return field
    }
};

export default translator;


// WEBPACK FOOTER //
// ./src/utils/translations.js